import React, { useState } from 'react';
import DropZone from '../components/Upload_Doc/DropZone';
import UploadButton from '../components/Upload_Doc/UploadButton';
import axios from '../axiosConfig';

const FileUpload = ({ accessToken }) => {
  const [excelFile, setExcelFile] = useState(null);
  const [wordFiles, setWordFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);

  const onDropExcel = (acceptedFiles) => {
    const file = acceptedFiles[0];
    if (file?.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      setExcelFile(file);
      setError(null);
    } else {
      setError('Invalid Excel file. Please upload a .xlsx file.');
    }
  };

  const onDropWord = (acceptedFiles) => {
    const validFiles = acceptedFiles.filter(
      (file) => file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    );
    if (validFiles.length) {
      setWordFiles(validFiles);
      setError(null);
    } else {
      setError('Invalid Word files. Please upload .docx files.');
    }
  };

  const handleUpload = async () => {
    if (!excelFile && wordFiles.length === 0) {
      return setError('Please upload at least one file (Excel or Word)');
    }

    const formData = new FormData();
    if (excelFile) formData.append('excel', excelFile);
    wordFiles.forEach((file) => formData.append('word', file));

    try {
      setUploading(true);
      setError(null);

      const { data } = await axios.post(
        `/upload`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${accessToken}`,
          },
          timeout: 600000,
        }
      );

      alert(data.message || 'Upload successful');
      setExcelFile(null);
      setWordFiles([]);
    } catch (err) {
      console.error('Upload failed:', err);
      const errorMsg = err?.response?.data?.message || 'Error uploading files. Please try again.';
      setError(errorMsg);
    } finally {
      setUploading(false);
    }
  };

  const clearExcelFile = () => setExcelFile(null);
  const clearWordFiles = () => setWordFiles([]);

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h2 className="text-2xl font-bold mb-6">Upload Files</h2>

      {/* Excel Upload */}
      <div className="mb-6">
        <h3 className="text-xl font-semibold mb-4">Upload Excel File (.xlsx)</h3>
        <DropZone
          onDrop={onDropExcel}
          accept=".xlsx"
          file={excelFile ? [excelFile] : []}
          text="Drag and drop an Excel file here, or click to select one"
        />
        {excelFile && (
          <button
            onClick={clearExcelFile}
            className="bg-red-500 text-white py-2 px-4 rounded mt-2 hover:bg-red-600 transition-colors duration-200"
          >
            Clear Excel File
          </button>
        )}
      </div>

      {/* Word Upload */}
      <div className="mb-6">
        <h3 className="text-xl font-semibold mb-4">Upload Word Documents (.docx)</h3>
        <DropZone
          onDrop={onDropWord}
          accept=".docx"
          file={wordFiles}
          isMultiple
          text="Drag and drop Word documents here, or click to select files"
        />
        {wordFiles.length > 0 && (
          <button
            onClick={clearWordFiles}
            className="bg-red-500 text-white py-2 px-4 rounded mt-2 hover:bg-red-600 transition-colors duration-200"
          >
            Clear Word Files
          </button>
        )}
      </div>

      {error && <p className="text-red-500 mb-4">{error}</p>}
      <UploadButton onClick={handleUpload} uploading={uploading} />
    </div>
  );
};

export default FileUpload;
